import React from "react";
import Navbar from "./navbar/Navbar";
import { Route, Routes } from "react-router-dom";
import "./home.css";
import Projet from "./projet/Projet";

const Home = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/projet" element={<Projet />} />
      </Routes>
    </>
  );
};

export default Home;
